import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { Store } from "@ngrx/store";
import { LocalStorageService } from "../../services/local-storage.service";
import { EFooterStyleInput } from "../../data-types/footer.enum";
import { EStorageType } from "../../data-types/storage.enum";
import { IAppState } from "../../store/state/app.state";
import { iconsLibrary } from "../../../theme/constants";
import { CoworkingService } from "../../services/coworking.service";
import {
  closeLoadingAction,
  showLoadingAction,
} from "../../store/actions/loading.action";
import { Router } from "@angular/router";

@Component({
  selector: "cowing-core-spaces-home",
  templateUrl: "./coworking-home-spaces.component.html",
  styleUrls: ["./coworking-home-spaces.component.scss"],
})
export class CoworkingSpacesHomeComponent implements OnInit, OnDestroy {
  public EFooterStyleInput = EFooterStyleInput;
  public coworkingId;
  iconsLibrary;
  essentialsServices;
  othersServices;
  allSpaces;
  subscription;
  @Input('isCompany') isCompany = false;
  constructor(
    private _store: Store<IAppState>,
    private coworkingService: CoworkingService,
    private router: Router
  ) {}
  async ngOnInit() {
    this.subscription =
      CoworkingService.instance.newCoworkingSelected.subscribe(
        async (newValue) => {
          this.coworkingId = newValue;
          await this.getCoworkingData();
        }
      );
    this.coworkingId = LocalStorageService.instance.get(
      EStorageType.ActiveCoworking
    );
    await this.getCoworkingData();

    CoworkingService.instance.newSpaceStatus.subscribe(
      (newStatus) => {
        if (newStatus) {
          let index: number = this.allSpaces.findIndex((elem) => {
            return elem.id === newStatus.id;
          });
          if (index !== -1) {
            this.allSpaces[index].status = newStatus.status;
          }
        }
      },
      (error: any) => {
        console.error("Error getting new space status:", error);
      }
    );
  }

  private async getCoworkingData() {
    this._store.dispatch(showLoadingAction({}));
    const allServices = await this.coworkingService.getCoworkingServices(
      this.coworkingId
    );
    this.essentialsServices = allServices.filter(
      (services) => services.type === "Essentials"
    );
    this.othersServices = allServices.filter(
      (services) => services.type === "Others" || services.type === "Free Covid"
    );
    this.allSpaces = await this.coworkingService.getCoworkingSpaces(
      this.coworkingId
    );
    this._store.dispatch(closeLoadingAction({}));
    return;
  }
  public get getInfoIcon() {
    return `${iconsLibrary["infoSvg"]}`;
  }
  public get getEditIcon() {
    return `${iconsLibrary["editSvg"]}`;
  }
  private navigateTo(link) {
    this.router.navigate([link]);
  }

  public editServices() {
    const typePage = this.isCompany ? 'company-services' : 'coworking-services';
    this.navigateTo(typePage);
  }

  public editSpaces() {
    const typePage = this.isCompany ? 'company-spaces' : 'coworking-spaces';
    this.navigateTo(typePage);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
